import {Icon, LabelRegular, TextMedium} from '@hm/fundamental'
import {mdiCheckBold} from '@mdi/js'
import React from 'react'

import {useTranslation} from '../../../hooks/useTranslation'
import {TfaData} from '../hooks/useTfaData'

type TwoFactorAuthInformationProps = {
  isAdAccount: boolean
  tfaData?: TfaData
}
export const TwoFactorAuthInformation = ({tfaData, isAdAccount}: TwoFactorAuthInformationProps) => {
  const {t} = useTranslation()

  if (!isAdAccount && (!tfaData?.isTfaEnabled || tfaData?.tfaType === 'none')) {
    return (
      <div className="flex flex-col gap-1">
        <TextMedium>{t('userInformationForm.tfa.tfaNotSetTitle')}</TextMedium>
        <LabelRegular className="text-foreground_faded">
          {t('userInformationForm.tfa.tfaNotSetDescription')}
        </LabelRegular>
      </div>
    )
  }

  const getTfaStatus = () => {
    if (tfaData?.isTfaEnabled) {
      if (tfaData?.tfaType === 'phoneNumber') {
        return t('userInformationForm.tfa.tfaPhoneNumber')
      }

      if (tfaData?.tfaType === 'authenticatorApp') {
        return t('userInformationForm.tfa.tfaAuthenticatorApp')
      }
    }

    if (isAdAccount) {
      return t('userInformationForm.tfa.tfaAdManaged')
    }
  }

  return (
    <div className="flex gap-2 items-center">
      <TextMedium className="text-foreground_faded">{getTfaStatus()}</TextMedium>
      <Icon path={mdiCheckBold} className="text-positive" />
    </div>
  )
}
